
export default function GroutFeatures() {
  const features = [
    {
      icon: 'ri-shield-star-line',
      title: 'Stain Resistant',
      description: 'Advanced formula repels stains and maintains color integrity over time.',
    },
    {
      icon: 'ri-water-flash-line',
      title: 'Waterproof',
      description: 'Elite Pro tier provides complete waterproof protection for wet areas.',
    },
    {
      icon: 'ri-bug-line',
      title: 'Antimicrobial',
      description: 'Built-in protection against mold, mildew, and bacteria growth.',
    },
    {
      icon: 'ri-contrast-drop-2-line',
      title: 'Color Options',
      description: 'Wide range of colors to match any tile and design aesthetic.',
    },
    {
      icon: 'ri-hand-heart-line',
      title: 'Easy to Clean',
      description: 'Smooth finish resists dirt accumulation and cleans effortlessly.',
    },
    {
      icon: 'ri-checkbox-circle-line',
      title: 'Crack Resistant',
      description: 'Flexible formula accommodates substrate movement without cracking.',
    },
  ];

  return (
    <section className="py-12 md:py-20 px-4 md:px-8 bg-white overflow-x-hidden">
      <div className="max-w-7xl mx-auto">
        <h2 className="font-['Montserrat'] font-bold text-2xl md:text-3xl lg:text-4xl text-center mb-4 text-[#1A1A1A]">
          Key Features
        </h2>
        <p className="text-base md:text-lg text-gray-600 text-center mb-10 md:mb-16 max-w-3xl mx-auto">
          Professional grout solutions designed for lasting beauty and performance.
        </p>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {features.map((feature) => (
            <div key={feature.title} className="text-center px-2">
              <div className="w-16 h-16 bg-[#F2C612] rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${feature.icon} text-3xl text-[#1A1A1A]`}></i>
              </div>
              <h3 className="font-['Montserrat'] font-bold text-lg md:text-xl mb-3 text-[#1A1A1A]">
                {feature.title}
              </h3>
              <p className="text-sm md:text-base text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
